import { render } from "./ZainOption.vue?vue&type=template&id=63d66932"
import script from "./ZainOption.vue?vue&type=script&lang=js"
export * from "./ZainOption.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__